import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { withPasswordManagerRefresh } from "./passwordManagerRequest";
import { getPasswordManagerAuthHeaders, passwordManagerUrl } from "./personaApi";
import { ICompanyPersona, ICompanyPersonaUpdate } from "./resetAutomationTypes";

interface IUpdateCompanyPersonaState {
	loading: boolean;
	error: string | null;
}

const initialState: IUpdateCompanyPersonaState = {
	loading: false,
	error: null,
};

export const updateCompanyPersona = createAsyncThunk<ICompanyPersona, ICompanyPersonaUpdate>(
	"passwordManager/updateCompanyPersona",
	async (payload, { rejectWithValue, dispatch }) => {
		try {
			const { companyId, ...body } = payload;
			const res = await withPasswordManagerRefresh(dispatch, () =>
				axios.put<ICompanyPersona>(passwordManagerUrl(`/Companies/${companyId}/persona`), body, {
					headers: getPasswordManagerAuthHeaders(),
				}),
			);
			return res.data;
		} catch (error: unknown) {
			return rejectWithValue(error instanceof Error ? error.message : "Failed to save company persona");
		}
	},
);

const updateCompanyPersonaSlice = createSlice({
	name: "passwordManager/updateCompanyPersona",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(updateCompanyPersona.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(updateCompanyPersona.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(updateCompanyPersona.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) || action.error.message || "Failed to save company persona";
			});
	},
});

export const updateCompanyPersonaReducer = updateCompanyPersonaSlice.reducer;
